import { observable, computed, action } from "mobx";
import TemplatesStore from "./templatesStore";

export class TemplateModel {
  store: TemplatesStore;

  @observable id: any = null;
  @observable json: any = {};
  @observable html: string = "";
  @observable name: string = "";
  @observable screenshot_path: string = "";
  @observable templateDataUrl: any;
  @observable user_id: number | null = null;
  @observable updatedAt: Date | null = null;

  constructor(store: TemplatesStore, json?: any) {
    this.store = store;
    if (json) {
      this.updateFromJson(json);
    }
  }

  save = async () => {
    return this.store.api.createOrUpdateTemplate(this.asJson);
  };

  @computed get asJson() {
    return {
      id: this.id,
      json: this.json,
      name: this.name,
      html: this.html,
      templateDataUrl: this.templateDataUrl,
      screenshot_path: this.screenshot_path
    };
  }

  isExample = () => {
    return this.name.toLowerCase().indexOf("example") !== -1;
  };

  @action updateFromJson(json: any) {
    if (json) {
      this.id = json.id;
      this.json =
        typeof json.json === "string" ? JSON.parse(json.json) : json.json;
      this.html = json.html;
      this.name = json.name;
      this.screenshot_path = json.screenshot_path;
      if (json.updatedAt) {
        this.updatedAt = new Date(json.updatedAt);
      }
    }
  }

  clone = async () => {
    const json = JSON.parse(JSON.stringify(this.asJson));
    delete json.id;
    json.name = "";
    const clone = new TemplateModel(this.store, json);
    const response: any = await clone.save();
    if (response.data.template) {
      clone.updateFromJson(response.data.template);
      this.store.onClone(clone);
    }
    return response;
  };

  delete = async () => {
    const deleteModelResponse = await this.store.api.deleteTemplate(this.id);
    this.store.onDelete(this);
    return deleteModelResponse;
  };
}
